/* Tecnobox · puente al checkout propio (Cóndor, 18-sept-2026).
   Todo lo que en el tema lleva al checkout de Shopify ("Ir a pagar" del
   carrito y del cajón) se desvía a nuestro checkout con el carrito real.
   Si algo falla al leer el carrito, se deja seguir al checkout de Shopify:
   nunca bloquear una compra. */
(function () {
  "use strict";
  var CHECKOUT = "https://checkout.tecnoboxchile.cl/checkout/";

  // _fbp/_fbc son cookies del dominio de la tienda: no cruzan solas a
  // checkout.tecnoboxchile.cl. Se mandan por la URL para que el checkout las
  // use en su Pixel y en la Conversions API (ver public/checkout/checkout.js
  // y functions/api/checkout/pagar.js). Si no hay _fbc pero la página trae
  // fbclid (recién llegado de un anuncio, antes de que el Pixel de la tienda
  // alcance a poner la cookie), se construye igual — es el formato que
  // documenta Meta para fbc armado a mano.
  function cookie(nombre) {
    var m = document.cookie.match("(?:^|; )" + nombre + "=([^;]*)");
    return m ? decodeURIComponent(m[1]) : "";
  }
  function fbpFbc() {
    var fbp = cookie("_fbp");
    var fbc = cookie("_fbc");
    if (!fbc) {
      var fbclid = new URLSearchParams(window.location.search).get("fbclid");
      if (fbclid) fbc = "fb.1." + Date.now() + "." + fbclid;
    }
    return { fbp: fbp, fbc: fbc };
  }

  // AddToCart del Pixel de Meta: "Agregar al carrito" ya lo dispara la app
  // de Facebook/Instagram de Shopify (necesita el /cart/add.js real para
  // verlo); "Comprar ahora" salta directo a nuestro checkout sin pasar por
  // ahí, así que hay que dispararlo a mano acá antes de redirigir.
  function dispararAddToCart(form) {
    try {
      if (!window.fbq) return;
      var fd = new FormData(form);
      var variantId = String(fd.get("id") || "");
      if (!variantId) return;
      var cantidad = Number(fd.get("quantity")) || 1;
      var precio = null;
      // Shopify expone el precio (en centavos) de la ficha acá cuando el
      // tema no lo saca de otra parte. Best-effort: sin esto, se manda
      // igual el evento pero sin `value`.
      try {
        var variantes = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.variants) || [];
        var v = variantes.filter(function (x) { return String(x.id) === variantId; })[0];
        if (v) precio = Number(v.price) / 100;
      } catch (e) { /* sin precio, se manda igual */ }
      fbq("track", "AddToCart", {
        content_ids: [variantId],
        content_type: "product",
        contents: [{ id: variantId, quantity: cantidad, item_price: precio }],
        num_items: cantidad,
        currency: "CLP",
        value: precio != null ? precio * cantidad : undefined,
      });
    } catch (e) { /* el Pixel nunca bloquea la compra */ }
  }

  function irAlCheckoutPropio(form, cupon) {
    var fb = fbpFbc();
    var actualizar = form
      ? fetch("/cart/update.js", { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } }).catch(function () {})
      : Promise.resolve();
    return actualizar
      .then(function () { return fetch("/cart.js", { headers: { Accept: "application/json" }, cache: "no-store" }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).map(function (i) { return i.variant_id + ":" + i.quantity; }).join(",");
        if (!items) throw new Error("carrito vacío");
        // Código: el que escribió recién, o el que el carrito ya traía aplicado
        // (p. ej. desde un enlace /discount/CODIGO de una campaña).
        // Qué pop-up sumó cada producto (propiedad _origen del carrito).
        var origen = (cart.items || []).filter(function (i) { return i.properties && i.properties._origen; })
          .map(function (i) { return i.variant_id + ":" + String(i.properties._origen).toLowerCase().replace(/[^a-z0-9-]/g, "").slice(0, 40); }).join(";");
        var codigo = cupon || ((cart.discount_codes || []).filter(function (d) { return d && d.code; })[0] || {}).code || "";
        window.location.href = CHECKOUT + "?items=" + encodeURIComponent(items)
          + (codigo ? "&cupon=" + encodeURIComponent(codigo) : "")
          + (origen ? "&origen=" + encodeURIComponent(origen) : "")
          + (fb.fbp ? "&fbp=" + encodeURIComponent(fb.fbp) : "")
          + (fb.fbc ? "&fbc=" + encodeURIComponent(fb.fbc) : "")
          + "&volver=" + encodeURIComponent(window.location.origin + "/cart");
      });
  }

  // Lo usa el campo de cupón del carrito (assets/theme.js) en vez de ir a
  // /discount/CODIGO?redirect=/checkout, que terminaba en el checkout de Shopify.
  window.tbCheckoutPropio = function (cupon) {
    return irAlCheckoutPropio(null, String(cupon || "").trim().slice(0, 60)).catch(function () {
      window.location.assign(cupon ? "/discount/" + encodeURIComponent(cupon) + "?redirect=/checkout" : "/checkout");
    });
  };

  function esLinkCheckout(a) {
    if (!a || !a.getAttribute) return false;
    var h = a.getAttribute("href") || "";
    return /^(https?:\/\/[^/]+)?\/checkout(\/|\?|$)/.test(h);
  }

  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("a");
    if (!esLinkCheckout(a) || e.defaultPrevented) return;
    e.preventDefault();
    irAlCheckoutPropio(null).catch(function () { window.location.href = a.href; });
  }, true);

  document.addEventListener("submit", function (e) {
    var boton = e.submitter;
    var form = e.target;
    var accion = form.getAttribute("action") || "";
    var vaAlCheckout = (boton && boton.name === "checkout") || /\/checkout/.test(accion);
    if (!vaAlCheckout) return;
    // "Comprar ahora" de la ficha de producto manda a /cart/add(.js): ahí el
    // producto todavía no estaba en el carrito, así que es un AddToCart real.
    // El botón "Ir a pagar" del carrito (action /cart) no dispara de nuevo:
    // esos productos ya avisaron su AddToCart cuando se agregaron.
    if (/\/cart\/add(\.js)?(\?|$)/.test(accion)) dispararAddToCart(form);
    e.preventDefault();
    irAlCheckoutPropio(/\/cart/.test(accion) ? form : null)
      .catch(function () { HTMLFormElement.prototype.submit.call(form); });
  }, true);

  // Al volver de un pedido confirmado, vaciar el carrito de la tienda.
  var p = new URLSearchParams(window.location.search);
  if (p.get("pedido_ok") === "1") {
    fetch("/cart/clear.js", { method: "POST", headers: { Accept: "application/json" } }).finally(function () {
      p.delete("pedido_ok");
      var q = p.toString();
      history.replaceState(null, "", window.location.pathname + (q ? "?" + q : "") + window.location.hash);
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    });
  }
})();
